import { useRoutes } from "react-router-dom";
import MainRoutes from "./mainRoutes";

export default function AppRoutes() {
  return useRoutes([MainRoutes], "");
}
